import React from 'react';
import './HowToUsePage.css'; // Pastikan path CSS sudah benar
import { FaSearch, FaCartPlus, FaArrowRight, FaUserEdit, FaCheckCircle } from 'react-icons/fa';

const HowToUsePage = () => {
    // Data untuk langkah-langkah agar JSX lebih bersih
    const steps = [
        {
            icon: <FaSearch />,
            title: "Cari Produk",
            description: "Gunakan kolom pencarian di bagian atas halaman atau pilih kategori untuk menemukan produk yang Anda butuhkan."
        },
        {
            icon: <FaCartPlus />,
            title: "Tambah ke Keranjang",
            description: "Pada halaman produk, tentukan jumlah yang diinginkan dan klik tombol '+ Keranjang'."
        },
        {
            icon: <FaArrowRight />,
            title: "Checkout",
            description: "Buka ikon keranjang di pojok kanan atas, periksa kembali pesanan Anda, lalu klik 'Pesan Sekarang'."
        },
        {
            icon: <FaUserEdit />,
            title: "Isi Data",
            description: "Jika Anda belum login, isi data diri Anda. Jika sudah, cukup pilih metode pengiriman."
        },
        {
            icon: <FaCheckCircle />,
            title: "Konfirmasi",
            description: "Setelah konfirmasi, pesanan Anda akan kami proses dan akan muncul di riwayat pesanan pada halaman profil Anda."
        }
    ];

    return (
        <div className="info-page-container">
            <div className="info-card">
                <h1>Cara Menggunakan Website</h1>
                
                <div className="how-to-use-list">
                    {steps.map((step, index) => (
                        <div key={index} className="step-item">
                            <div className="step-icon">
                                {step.icon}
                            </div>
                            <div className="step-content">
                                <h3 className="step-title">{index + 1}. {step.title}</h3>
                                <p className="step-description">{step.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HowToUsePage;